const ResolvedTicketIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="4" fill="#FBEDFD" />
      <g clip-path="url(#clip0_16488_47727)">
        <path
          d="M19.3333 16H16V11"
          stroke="#CF14EB"
          stroke-width="1.25"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M24.3332 16.0001C24.3332 20.6024 20.6022 24.3334 15.9998 24.3334C11.3975 24.3334 7.6665 20.6024 7.6665 16.0001C7.6665 11.3977 11.3975 7.66675 15.9998 7.66675"
          stroke="#CF14EB"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M21.7063 9.47542C21.8514 9.60358 21.9926 9.73636 22.1296 9.87341C22.2666 10.0105 22.3993 10.1518 22.5273 10.297M18.5 7.66675C18.9018 7.78554 19.2957 7.9387 19.6778 8.12228M23.8646 12.2956C24.0539 12.686 24.2116 13.0889 24.3333 13.5001"
          stroke="#CF14EB"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_16488_47727">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(6 6)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ResolvedTicketIcon;
